import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { 
    AccountCircle as AccountCircleIcon,
    Login as LoginIcon
} from '@mui/icons-material';

// Import logo
import sikkimSeal from '../../static/assets/imgs/seal_of_sikkim_whitebg_256px.png';

const PublicLayout = ({ children }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogin = () => {
    navigate('/login');
  };

  const handleDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar 
        position="static" 
        sx={{ 
          backgroundColor: 'white', 
          color: theme.palette.primary.main,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
            <Box display="flex" alignItems="center">
              <img 
                src={sikkimSeal} 
                alt="Government of Sikkim" 
                style={{ 
                  width: '80px', 
                  marginRight: theme.spacing(2) 
                }} 
              />
              <Box>
                <Typography 
                  variant="h6" 
                  component="div" 
                  sx={{ 
                    fontWeight: 'bold',
                    fontSize: { xs: '0.9rem', md: '1.25rem' }
                  }}
                >
                  NC ExMS | DAC Mangan
                </Typography>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    display: { xs: 'none', sm: 'block' },
                    opacity: 0.8 
                  }}
                >
                  Government of Sikkim
                </Typography>
              </Box>
            </Box>
            
            <Box>
              {isAuthenticated ? (
                <Button
                  variant="contained"
                  onClick={handleDashboard}
                  sx={{ ml: 2 }}
                  startIcon={<AccountCircleIcon />}
                >
                  Dashboard
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleLogin}
                  sx={{ ml: 2 }}
                  startIcon={<LoginIcon />}
                >
                  Employees' Login
                </Button>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>

      {/* Footer */}
      <Box 
        component="footer" 
        sx={{ 
          bgcolor: theme.palette.grey[100], 
          py: 4,
          mt: 'auto'
        }}
      >
        <Container maxWidth="lg">
          <Box textAlign="center">
            <Typography variant="h6" color="text.secondary" align="center">
              © {new Date().getFullYear()} Government of Sikkim. All rights reserved.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Developed by IT Section, District Administrative Centre, Mangan
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default PublicLayout;
